import { z } from "zod";

/** Shared `firmId` / audit fields for firm-scoped entities. */
export const commonFirmFields = z.object({
  firmId: z.string(),
  dateCreated: z.string(),
  dateModified: z.string(),
});
